export function getAll() {
  var items = [
    {
      value: 0,
      name: "Manually",
      text: "手動",
    },
    {
      value: 1,
      name: "AutoForDate",
      text: "月份自動產生(2026120001)",
    },
    {
      value: 2,
      name: "SameAsPhoneNumber",
      text: "同手機號碼",
    },
    {
      value: 3,
      name: "AutoForDateYYMM",
      text: "月份自動產生(261200001)",
    },
  ];
  return items;
}
